import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5a9386f2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-main"
};
import { computed } from 'vue';
import { useRoute, RouterView } from 'vue-router';
import { useStore } from 'vuex';
import { nameComponent } from '@/utils/viewUtil';
export default /*#__PURE__*/_defineComponent({
  __name: 'AppMain',
  setup(__props) {
    const $route = useRoute();
    const $store = useStore();
    const cachedViews = computed(() => $store.state.tagsView.cachedViews);
    const key = computed(() => $route.path);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createVNode(_unref(RouterView), null, {
        default: _withCtx(({
          Component,
          route
        }) => [(_openBlock(), _createBlock(_KeepAlive, {
          include: cachedViews.value
        }, [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(nameComponent)(Component, route)), {
          style: {
            "height": "100%"
          }
        }))], 1032, ["include"]))]),
        _: 1
      })]);
    };
  }
});